import React, { useState } from 'react';
import { MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import { format } from 'date-fns';

const generateDateOptions = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const options = [];

  for (let year = currentYear; year >= currentYear - 1; year--) {
    const startMonth = year === currentYear - 1 ? 8 : 0;
    const endMonth = year === currentYear - 1 ? 11 : currentMonth;
    for (let month = endMonth; month >= startMonth; month--) {
      const secondHalfStart = new Date(year, month, 16);
      const lastDay = new Date(year, month + 1, 0).getDate();
      const secondHalfEnd =
        year === currentYear && month === currentMonth
          ? new Date(year, month, currentDay, 23, 59, 59)
          : new Date(year, month, lastDay, 23, 59, 59);

      const firstHalfStart = new Date(year, month, 1);
      const firstHalfEnd = new Date(year, month, 15, 23, 59, 59);

      options.push({ start: secondHalfStart, end: secondHalfEnd });
      options.push({ start: firstHalfStart, end: firstHalfEnd });
    }
  }

  return options.slice(0, 12);
};

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// const FiltroQuincenas = ({ onDesdeDate, onHastaDate, handleResetFechas, hastaDate, desdeDate }) => {
//   const dateOptions = generateDateOptions();

//   const handleSelectChange = (event) => {
//     const selectedOption = event.target.value;
//     const { start, end } = JSON.parse(selectedOption);

//     const startDate = new Date(start);
//     const endDate = new Date(end);
//     endDate.setDate(endDate.getDate() + 1); // Add one day to endDate

//     console.log({ startDate, endDate });
//     handleResetFechas();
//     onDesdeDate({ target: { value: formatDate(startDate) } });
//     onHastaDate({ target: { value: formatDate(endDate) } });
//   };

//   return (
//     <FormControl>
//       <InputLabel>Escoger quincena</InputLabel>
//       <Select
//         value={JSON.stringify({ start: '', end: '' })}
//         onChange={handleSelectChange}
//         label="Escoger quincena"
//         style={{ minWidth: 150 }}
//       >
//         {dateOptions.map((option, index) => (
//           <MenuItem key={index} value={JSON.stringify(option)}>
//             {`${index % 2 === 0 ? '2da' : '1ra'} ${format(option.start, 'MMM/yy')}`}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );
// };

// export default FiltroQuincenas;

const FiltroQuincenas = ({ onDesdeDate, onHastaDate, handleResetFechas, hastaDate, desdeDate }) => {
  const dateOptions = generateDateOptions();
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedOption(selectedOption); // Update the selectedOption state
    const { start, end } = JSON.parse(selectedOption);

    const startDate = new Date(start);
    const endDate = new Date(end);
    // endDate.setDate(endDate.getDate() + 1); // Add one day to endDate

    handleResetFechas();
    onDesdeDate({ target: { value: formatDate(startDate) } });
    onHastaDate({ target: { value: formatDate(endDate) } });
  };

  return (
    <FormControl>
      <InputLabel>Escoger quincena</InputLabel>
      <Select
        value={selectedOption} // Set the value prop to selectedOption
        onChange={handleSelectChange}
        label="Escoger quincena"
        style={{ minWidth: 150 }}
      >
        {dateOptions.map((option, index) => (
          <MenuItem key={index} value={JSON.stringify(option)}>
            {`${index % 2 === 0 ? '2da' : '1ra'} ${format(option.start, 'MMM/yy')}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FiltroQuincenas;
